<template>
    <router-view />
</template>

<script>
export default {
    name: 'GoodManageLayout',
};
</script>

<style scoped></style>
